<template>
  <div>
    <custom-dialog :visible="visible" width="1180px" :title="model.title" v-on="$listeners">
      <div class="dialog-body">
        <div class="item-title">{{ $t('dms_device_project_dialog.she_bei_xin_xi') }}</div>
        <custom-table :data="tableList" :index="true" tableCode="deviceProject" @filter="filterChange" @sort="sortChange" :filterArr="['useLocation']"></custom-table>
        <div class="item-title" style="margin-top: 16px">{{ $t('dms_device_project_dialog.xiang_mu_xin_xi') }}</div>
        <el-form :model="form" ref="form" size="mini" label-width="auto" :rules="rules">
          <el-form-item :label="$t('dms_device_project_dialog.xiang_mu')" prop="locationId">
            <el-input size="small" v-model="form.locationName" style="width: 280px" :disabled="true"></el-input>
            <el-button size="small" style="margin-left: 8px" type="primary" @click="selectProject()">
              {{ $t('dms_device_project_dialog.xuan_ze_xiang_mu') }}
            </el-button>
          </el-form-item>
          <el-form-item :label="$t('dms_device_project_dialog.qu_yu')" prop="siteId">
            <el-input size="small" v-model="form.siteName" style="width: 280px" :disabled="true"></el-input>
            <el-button size="small" style="margin-left: 8px" type="primary" @click="onSelectSite()" :disabled="!form.locationId">
              {{ $t('dms_device_project_dialog.xuan_ze_qu_yu') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('Common.com_close') }}</el-button>
        <el-button type="primary" :disabled="!form.locationId || !form.siteId" @click="onSave">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
    <location-select-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onLocationSelect"></location-select-dialog>
    <site-select-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="onSiteSelect"></site-select-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import locationSelectDialog from '@/pages/dms/components/location_select_dialog.vue';
import siteSelectDialog from '@/pages/dms/components/site_select_dialog.vue';

export default {
  mixins: [dialogMixins],
  components: { locationSelectDialog, siteSelectDialog },
  data() {
    return {
      createMode: '',
      tableList: [],
      // 原本的项目id  用于判断如果没有变更就不给保存 只能修改
      locationId: '',
      siteId: '',
      form: {
        locationId: '',
        locationName: '',
        siteId: '',
        siteName: '',
      },
      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
    };
  },
  mounted() {
    this.getDeviceInfo();
  },

  computed: {
    rules() {
      return {
        locationId: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        siteId: {
          required: true,
          message: this.$t('Common.com_required'),
        },
      };
    },
  },
  methods: {
    onLocationSelect: function (row) {
      this.form.locationId = row.locationId;
      this.form.locationName = row.locationName;
      // 置空
      this.form.siteId = '';
      this.form.siteName = '';
    },
    // 获取设备信息
    getDeviceInfo() {
      this.$getJSON(`${apis.DeviceInfo}/${this.model.data.deviceId}`).then((res) => {
        this.tableList = [res.data];
        this.locationId = res.data.locationId || '';
        this.siteId = res.data.siteId || '';
        this.createMode = res.data.createMode;
        this.$setFormatData(this.form, res.data);
      });
    },
    changeProject(project) {
      this.form.locationName = project.locationName;
    },
    onSave() {
      this.$refs.form.validate((val) => {
        if (val) {
          this.$postJSON(
            apis.DeviceChangeLocation,
            {
              bodyNum: this.model.data.bodyNum,
              locationName: this.form.locationName,
              locationId: this.form.locationId,
              siteId: this.form.siteId,
              siteName: this.form.siteName,
            },
            true
          ).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.$emit('success');
            this.visible = false;
          });

          // 特殊情况：1.项目区域没有变化, 2.初始是默认区域然后清空了不做处理(项目没变更)
          // if (this.form.locationId === this.locationId && (this.form.siteId === this.siteId || (this.createMode === 0 && !this.form.siteId))) {
          //   this.$message({
          //     type: 'success'
          //   });
          //   this.$emit('success');
          //   this.visible = false;
          //   return;
          // }
          // if (this.form.siteId) {
          //   this.$postJSON(apis.stockGroupUpdate, {
          //     ...this.form, bodyNum: this.model.data.bodyNum
          //   }, true).then(() => {
          //     this.$message({
          //       type: 'success'
          //     });
          //     this.$emit('success');
          //     this.visible = false;
          //   });
          // } else {

          // }
        }
      });
    },
    // 新增项目
    selectProject: function () {
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('dms_device_project_dialog.xuan_ze_xiang_muo', [this.model.data.orgName]);
      this.dialogModel.data = {
        orgId: this.model.data.orgId,
        orgName: this.model.data.orgName,
      };
      this.dialogVisible = true;
    },
    onSelectSite: function () {
      this.dialogModel1.type = 'add';
      this.dialogModel1.title = this.$t('dms_device_project_dialog.xuan_ze_qu_yuo', [this.form.locationName]);
      this.dialogModel1.data = {
        orgId: this.model.data.orgId,
        orgName: this.model.data.orgName,
        locationId: this.form.locationId,
      };
      this.dialogVisible1 = true;
    },
    onSiteSelect: function (row) {
      // this.$refs.location.getSelectList();
      this.form.siteId = row.siteId;
      this.form.siteName = row.siteName;
    },
  },
};
</script>

<style lang="scss">
.device-project-dialog {
  .el-form-item__label {
    width: 100%;
    text-align: left;
  }

  .el-select {
    width: 100%;
  }

  .dialog-body {
    height: 413px;
    width: 100%;
    padding: 0 !important;
    display: flex;
    border-bottom: 1px solid #e9ebec;
    .msg-content {
      width: 260px;
      padding: 0 24px;
      height: 100%;
      background: #f8f9fb;
      .title {
        $h: 60px;
        height: $h;
        line-height: $h;
        color: #495057;
        font-weight: bold;
        font-size: 14px;
      }
      .msg-list {
        > li {
          overflow: hidden;
          padding-top: 9px;
          padding-bottom: 10px;
          color: #6c757d;
          font-size: 12px;
          line-height: 17px;
          border-bottom: 1px solid #eef2f7;
          .key {
            float: left;
            width: 50%;
          }
          .val {
            float: left;
            text-align: right;
            width: 50%;
          }
        }
      }
    }
    .input-container {
      flex: 1;
      padding: 24px 24px 0 24px;
      background: #fff;
    }
  }
}
</style>
